import React from "react";
import styles from "./PrivacyAndPolicy.module.css";

const PrivacyAndPolicy = () => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Privacy Policy</h2>
        <p className={styles.date}>Updated 02/22/2023</p>

        <div className={styles.textContainer}>
          <h4 className={styles.title}>Our Commitment to Your Privacy</h4>
          <p className={styles.text}>
            Our Privacy Policy tells you what personally identifiable
            information chitchatgame.com may collect from you, how
            chitchatgame.com may process your personally identifiable
            information, how you can limit our use of your personally
            identifiable information, and your rights to obtain, modify and/or
            delete any personally identifiable information chitchatgame.com has
            collected from you.
          </p>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>Information we Collect</h4>
          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              Information you provide chitchatgame.com
            </li>
            <p className={styles.text}>
              chitchatgame.com collects personal information when you request
              information about our service or otherwise voluntarily provide
              such information through our app.
            </p>
            <li className={styles.text}>
              Generally, you will have control over the amount and type of
              information you provide to us when using our app.
            </li>
            <p className={styles.text}>
              As a visitor you can browse our app to find out more.
            </p>
            <li className={styles.text}>Cookies</li>
            <p className={styles.text}>
              Like many other apps, we use “Cookies.” A Cookie is a small piece
              of data stored on your computer or mobile device by our app. We
              use Cookies to identify the areas of our app that you have
              visited. We also use cookies to enhance your online experience by
              eliminating the need to log in multiple times for specific
              content. Finally, we may use Cookies to personalize the content
              that you see on our app or to customize marketing and other
              information we provide to you.
            </p>
            <li className={styles.text}>
              Other Automatically-Gathered Information
            </li>
            <p className={styles.text}>
              chitchatgame.com may automatically record information when you
              visit its app, including the URL, IP address, browser type and
              language, and the date and time of your visit. chitchatgame.com
              uses this information to analyze trends among its customers to
              help improve its app or customize communications and information
              that you receive from us. If combined with other information we
              know about you from previous visits, the data possibly could be
              used to identify you personally, even if you are not signed in to
              our app.
            </p>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>How Information is Used</h4>
          <p className={styles.text}>
            When chitchatgame.com uses or processes personal data about you, it
            does so only as necessary to provide the service you use or
            otherwise with your consent, to comply with applicable law, or to
            fulfill other legitimate interests of you or us as described in this
            Policy. Through our app, you will be provided with the choice of
            which types of communications you will receive with us, and the
            ability to change those choices whenever you want.
          </p>
          <ol type="1" className={styles.list}>
            <li className={styles.text}>
              Information we process with your consent
            </li>
            <p className={styles.text}>
              Through certain actions when otherwise there is no contractual
              relationship between us, such as when you browse our app or ask us
              to provide you more information about our business, you provide
              your consent to us to process information that may be personally
              identifiable information.
            </p>
            <p className={styles.text}>
              Wherever possible, we aim to obtain your explicit consent to
              process this information, for example, by asking you to agree to
              our use of Cookies or to receive communications from us.
            </p>
            <p className={styles.text}>
              We continue to process your information on this basis until you
              withdraw your consent or it can be reasonably assumed that your
              consent no longer exists.
            </p>
            <p className={styles.text}>
              You may withdraw your consent at any time by instructing us using
              the contact information at the end of this Policy. However, if you
              do so, you may not be able to use our app further.
            </p>
            <li className={styles.text}>
              Generally, you will have control over the amount and type of
              information you provide to us when using our app.
            </li>
            <p className={styles.text}>
              As a visitor you can browse our app to find out more.
            </p>
            <li className={styles.text}>
              Legally Required Releases of Information
            </li>
            <p className={styles.text}>
              We may be legally required to disclose your personally
              identifiable information, if such disclosure is (a) required by
              law, or other legal process; (b) necessary to assist law
              enforcement officials or government enforcement agencies; (c)
              necessary to investigate violations of or otherwise enforce our
              Legal Terms; (d) necessary to protect us from legal action or
              claims from third parties including you; and/or (e) necessary to
              protect the legal rights, personal/real property, or personal
              safety of our company, clients, third party partners, employees,
              and affiliates.
            </p>
          </ol>
        </div>
        <div className={styles.textContainer}>
          <h4 className={styles.title}>
            Obtaining, Changing or Deleting Your Iinformation
          </h4>
          <ol type="1" className={styles.list}>
            <li className={styles.text}>Access to your personal information</li>
            <p className={styles.text}>
              To obtain a copy of all information chitchatgame.com maintains
              about you, you may send us a request using the contact information
              at the end of this Policy or, if available, through a tool on our
              app. After receiving the request, we will tell you when we expect
              to provide you with the information, and whether we require any
              fee for providing it to you.
            </p>
            <li className={styles.text}>Remove or Change your Information</li>
            <p className={styles.text}>
              If you wish us to remove or change personally identifiable
              information that you have provided us, you may contact us at the
              contact information at the end of this Policy or if available
              through a tool on our app.
            </p>
            <li className={styles.text}> Verification of your Information</li>
            <p className={styles.text}>
              When we receive any request to access, edit or delete personally
              identifiable information, we will first take reasonable steps to
              verify your identity before granting you access or otherwise
              taking any action. This is important to safeguard your
              information.
            </p>
          </ol>
        </div>
        <div className={styles.textContainer}>
          {" "}
          <h4 className={styles.title}>Retention Period for Personal Data</h4>
          <p className={styles.text}>
            Except as otherwise mentioned in this Policy, chitchatgame.com keeps
            your personally identifiable information only for as long as
            required:
          </p>
          <p className={styles.text}>
            * to continue to provide the best possible user experience to
            visitors who return to our app to collect information;
          </p>
          <p className={styles.text}>
            * to comply with other law, including for any period demanded by tax
            authorities; or
          </p>
          <p className={styles.text}>
            * to support a claim or defense in any court or in any legal,
            regulatory or administrative proceeding.
          </p>
        </div>
        <div className={styles.textContainer}>
          {" "}
          <h4 className={styles.title}>Limitation of Liability</h4>
          <p className={styles.text}>
            You assume the sole risk of transmitting your information as it
            relates to the use of this app, and for any data corruptions,
            intentional interceptions, intrusions or unauthorized access to
            information, or of any delays, interruptions to or failures
            preventing the use this app. In no event shall we be liable for any
            direct, indirect, special, consequential or monetary damages,
            including fees, and penalties in connection with your use of
            materials posted on this app or connectivity to or from this app to
            any other app.
          </p>
        </div>
        <div className={styles.textContainer}>
          {" "}
          <h4 className={styles.title}>Protecting Your Child’s Privacy</h4>
          <p className={styles.text}>
            Even though our app is not designed for use by anyone under the age
            of 18, we realize that a child may attempt to access the app. We do
            not knowingly collect personally identifiable information from a
            child. If you are a parent or guardian and believe your child is
            using our app, please contact us. We may ask for proof of
            identification before we remove any information to prevent malicious
            removal of information. If we discover on our own that a child is
            accessing our app, we will delete the information as soon as we
            discover it, we will not use the information for any purpose, and we
            will not disclose the information to third parties. You acknowledge
            that we do not verify the age of our users nor do we have any
            liability to do so. If you are a child, please seek the permission
            of a parent or guardian before accessing the app.{" "}
          </p>
        </div>
        <div className={styles.textContainer}>
          {" "}
          <h4 className={styles.title}>Governing Law</h4>
          <p className={styles.text}>
            This Privacy Policy and any claim, controversy or dispute arising
            under or related to this Privacy Policy shall be governed by and
            construed in accordance with the internal laws of the state of New
            York applicable to privacy policies made and to be performed in such
            jurisdictions without regard to conflicts of law principles thereof.
          </p>
        </div>
        <div className={styles.textContainer}>
          {" "}
          <h4 className={styles.title}>Changes to Our Privacy Policy</h4>
          <p className={styles.text}>
            chitchatgame.com reserves the right to change this privacy policy at
            any time. If we decide to change this Privacy Policy, we will post
            those changes on the app so our users are always aware of what
            information we collect, use, and disclose. In all cases, your
            continued use of our app after any change to this Privacy Policy
            will constitute your acceptance of such change.
          </p>
        </div>
        <div className={styles.textContainer}>
          {" "}
          <h4 className={styles.title}>Acceptance</h4>
          <p className={styles.text}>
            By accessing our app, you have willingly accepted the terms of this
            Privacy Policy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyAndPolicy;
